export const pvqList = [
  {
    key: 'A1',
    color: '#FA8072',
  },
  {
    key: 'A2',
    color: '#FFD700',
  },
  {
    key: 'A3',
    color: '#32CD32',
  },
  {
    key: 'A4',
    color: '#2E8B57',
  },
  {
    key: 'A5',
    color: '#1E90FF',
  },
  {
    key: 'A6',
    color: '#8B008B',
  },
  {
    key: 'A7',
    color: '#FF1493',
  },
  {
    key: 'A8',
    color: '#DC143C',
  },
  {
    key: 'A9',
    color: '#9370DB',
  },
  {
    key: 'A10',
    color: '#4682B4',
  },
];
